import { Injectable, Pipe, PipeTransform, inject } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import * as changeCase from 'change-case'
import { FuseTranslationLoaderService } from '../../services/translation-loader.service'
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'translateStorageMovementType',
})
export class TranslateStorageMovementTypePipe implements PipeTransform {
  constructor(
    private readonly translateService: TranslateService,
    private readonly translationLoaderService: FuseTranslationLoaderService
  ) {
    this.translationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public transform(value?: string): string {
    return this.translateService.instant(`TRANSLATE_STORAGE_MOVEMENT_TYPE.${changeCase.constantCase(String(value))}`)
  }
}
